import _, { rest } from 'lodash';
import React, { useContext, useState } from 'react';
import { Dropdown, Badge } from 'react-bootstrap';
import { FormContext } from 'blaze-form';
import FormInputListSearch from '../form/control/FormInputListSearch';
import { modal } from '../modal/ModalEmitter';
import AuthService from '../../services/AuthService';

const popperConfig = {
  strategy: 'fixed',
};

/*
  Primarily used for EQS to link an addon to a Repair Order or a Purchase Order
  RO -> SMM1 PO -> AVI11A (for New Units) AVI11B (for Used Units)
*/
const FormInputLinkOrder = ({ field, onChange, value, ...rest }) => {
  const { manager } = useContext(FormContext);
  const [oldOrderNum, setOldOrderNum] = useState('');
  const [orderNum, setOrderNum] = useState(value);

  const [searchPO, setSearchPO] = useState(false);
  const [searchRO, setSearchRO] = useState(false);

  const revertToOld = () => {
    setOrderNum(oldOrderNum);
    setOldOrderNum('');
    onChange(field.name, oldOrderNum);
  };

  const clearOrder = () => {
    setOldOrderNum(orderNum);
    setOrderNum('');
    onChange(field.name, '');
  };

  const handleEditOrder = lookupKey => {
    const [type, itemId] = lookupKey.split(':');
    let itemName = 'SMM1';

    if (type === 'PO') {
      const condition = manager.getValue('condition');
      itemName = condition === 'U' ? 'AVI11B' : 'AVI11A';
    }

    if (!AuthService.hasPermission(itemName)) {
      return;
    }

    modal.open('listEditItem', {
      action: 'edit',
      itemName,
      lookupKey: itemId,
      render: 'listEditItem',
      title: `Edit ${type === 'PO' ? 'Purchase' : 'Repair'} Order ${itemId}`,
      submitCallback: () => {},
    });
  };

  const handleNewRepairOrder = () => {
    modal.open('listEditItem', {
      action: 'new',
      itemName: 'SMM1',
      lookupKey: '_new',
      render: 'listEditItem',
      title: 'Create Repair Order',
      query: { SMM1__104: manager.getValue('vin') },
      submitCallback: response => {
        const itemId = _.get(response, 'responses[0].itemid');
        setOrderNum(`RO:${itemId}`);
        onChange(field.name, `RO:${itemId}`);
      },
    });
  };

  const handleNewPurchaseOrder = () => {
    const condition = manager.getValue('condition');
    const itemName = condition === 'U' ? 'AVI11B' : 'AVI11A';

    // TODO Possible to know GL account?
    modal.open('listEditItem', {
      action: 'new',
      itemName,
      lookupKey: '_new',
      render: 'listEditItem',
      title: 'Create Purchase Order',
      query: { PO__12: [manager.getValue('vehicleId')] },
      submitCallback: response => {
        const itemId = _.get(response, 'data.responses[0].itemid');
        setOrderNum(`PO:${itemId}`);
        onChange(field.name, `PO:${itemId}`);
      },
    });
  };

  const handleSelectedPO = (suggestion, fullSuggestion) => {
    const itemId = fullSuggestion.split(':')[0];
    setSearchPO(false);
    setOrderNum(`PO:${itemId}`);
    onChange(field.name, `PO:${itemId}`);
  };

  const handleSelectedRO = (suggestion, fullSuggestion) => {
    const itemId = fullSuggestion.split(':')[0];
    setSearchRO(false);
    setOrderNum(`RO:${itemId}`);
    onChange(field.name, `RO:${itemId}`);
  };

  if (searchRO) {
    const search = {
      page: 'SMM1',
    };

    return (
      <FormInputListSearch
        {...rest}
        field={field}
        search={search}
        value={orderNum}
        onSuggestionSelected={handleSelectedRO}
      />
    );
  }

  if (searchPO) {
    const condition = manager.getValue('condition');
    const pageName = condition === 'U' ? 'AVI11B' : 'AVI11A';

    const search = {
      page: pageName,
    };

    return (
      <FormInputListSearch
        {...rest}
        field={field}
        search={search}
        value={orderNum}
        onSuggestionSelected={handleSelectedPO}
      />
    );
  }

  if (orderNum) {
    const [type, itemId] = orderNum.split(':');
    return (
      <div className="form-group display-only">
        <div className="displayonly-container">
          <div className="value" onClick={() => handleEditOrder(orderNum)}>
            <Badge variant="primary">{type}</Badge> <Badge>{itemId}</Badge>
          </div>
          <div onClick={clearOrder} className="hover-icon">
            <i className="fal fa-times" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant="secondary" block>
        Link
      </Dropdown.Toggle>

      <Dropdown.Menu align="right" popperConfig={popperConfig}>
        <Dropdown.Item onClick={handleNewRepairOrder} disabled={!AuthService.hasPermission('SMM1')}>
          New Repair Order
        </Dropdown.Item>
        <Dropdown.Item onClick={handleNewPurchaseOrder} disabled={!AuthService.hasPermission('AVI11A')}>
          New Purchase Order
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setSearchRO(true)} disabled={!AuthService.hasPermission('SMM1')}>
          Existing Repair Order
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setSearchPO(true)} disabled={!AuthService.hasPermission('AVI11A')}>
          Existing Purchase Order
        </Dropdown.Item>
        {oldOrderNum && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item onClick={revertToOld}>Use "{oldOrderNum}"</Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FormInputLinkOrder;
